import { render, staticRenderFns } from "./proBaseField.vue?vue&type=template&id=2d6f1e34&"
import script from "./proBaseField.vue?vue&type=script&lang=js&"
export * from "./proBaseField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports